/* global filtersData */
import React, { Component } from 'react';
import ReactModal from 'react-modal';
import classNames from 'classnames';
import { connect } from 'react-redux';

import {CloseIcon} from './html';
import {modalStyle} from '../configs';
import {clickToMap, clickApplyFilters, cleanFilter} from '../appActions';

class MapList extends Component {
  render () {
    let selectMaps = this.props.selectMaps;
    let maps = filtersData.map.checkboxes.sort((a, b) => {
      if (a.title > b.title)
        return 1;
      if (a.title < b.title)
        return -1;
      return 0;
    });

    return(
      <div className="filter_popup__content">
        {maps.map(m =>
          <div key={m.id}>
            <span className={classNames("filter_popup__map_name", {'filter_popup__selected': selectMaps.indexOf(m.id) !== -1})}
                 key={m.id}
                 onClick={() => this.props.clickToMap(m.id)}>
              {m.title}
            </span>
          </div>
        )}
      </div>
    );
  }
}

class FilterMenu extends Component {
  render() {
    let selectMapsLength = this.props.selectMapsLength;
    return (
      <div className="filter_popup__menu text-lg">
        <span style={{position: 'absolute', left: '10px'}}>Фильтр:</span>
        <span style={{fontWeight: 'bold'}}>Карты {selectMapsLength ? `(${selectMapsLength})` : ''}</span>
      </div>
    );
  };
}

class Search extends Component {
  render () {
    return (
      <div className="filter_popup__search">
        <div className="filter_popup__search_button" onClick={this.props.clickApplyFilters}>показать</div>
      </div>
    );
  }
}

class DeleteMaps extends Component {
  render () {
    return (
      this.props.maps.length ?
        <div>
          <span className="filter_popup__delete">Карты: </span>
          {this.props.maps.map( mId => {
            let m = filtersData.map.checkboxes.find((_m) => _m.id == mId);
            return (
              <span className="filter_popup__map_name filter_popup__delete filter_popup__selected"
                    key={m.id}
                    >
                    {m.title}
                <CloseIcon onClick={() => this.props.clickToMap(m.id)} />
              </span>
            );
          })}
        </div>
        : null
    );
  }
}

 class Filter extends Component {
  constructor(props){
    super(props);
    this.state = {showModal: false};
    this.open = () => this.setState({showModal: true});
    this.close = () => this.setState({showModal: false});
  }

  render() {
    let mapLength = this.props.filters.maps.length;
    let filtersToLoad = this.props.filtersToLoad;

    let filterIsNotEmpty = () => filtersToLoad.maps.length;

    return (
      <div>
        <div className="filter">
          {filterIsNotEmpty() ? <CloseIcon onClick={this.props.cleanFilter} className="filter_popup__close" /> : null}
          <div className="filter__title" onClick={this.open}>Фильтр</div>
          <DeleteMaps maps={filtersToLoad.maps} clickToMap={(map) => this.props.clickToMap(map, true)}/>
        </div>
        <ReactModal isOpen={this.state.showModal} onRequestClose={this.close} contentLabel="" style={modalStyle} className="filter_popup__modal">
          <div className="filter_popup">
            <CloseIcon onClick={this.close} className="filter_popup__close" />
            <FilterMenu selectMapsLength={mapLength}/>
            <MapList selectMaps={this.props.filters.maps} clickToMap={this.props.clickToMap}/>
            {
              mapLength ?
                <Search clickApplyFilters={() =>{this.props.clickApplyFilters(); this.close();}}/>
                : null
            }
          </div>
        </ReactModal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  let filters = state.app.filters;
  let filtersToLoad = state.app.filtersToLoad;

  return {
    filters,
    filtersToLoad,
  }
}

function mapAppActions(dispatch) {
  return {
    clickToMap : (map, force) => dispatch(clickToMap(map, force)),
    clickApplyFilters: () => dispatch(clickApplyFilters()),
    cleanFilter: () => dispatch(cleanFilter()),
  }
}

export default connect(mapStateToProps, mapAppActions)(Filter);


// WEBPACK FOOTER //
// ./src/components/filter.js